
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { timeForPage, trackEvent } from "./UtilsFunction";
import "./TextToBold.css";
import "./CaptionIdeas.css";
import ScrollTag from "./ScrollTag";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";

const CAPTION_TOPICS = [
  {
    label: "Love",
    emoji: "❤️",
   
  },
  {
    label: "Birthday",
    emoji: "🎂",
    
  },
  {
    label: "Friends",
    emoji: "🫶",
  
  },  
    {
    label: "Attitude",
    emoji: "😎",
   
  },

   {
    label: "Nature",
    emoji: "🌳",
   
  },


  //  {
  //   label: "Travel",
  //   emoji: "✈️",
  //   value: "travel",
  //   captions: TravelCaptions,
  // },
  
];


const captionData = {

love: [
  // Top: Broadly relatable and emotionally appealing
  { text: "I'd choose you in every version of my life ❤️❤️", category: "Romantic" },
  { text: "Your hand is my favourite place 🤍", category: "Cute" },
    { text: "It's not just that I love you. Life really feels special with you. ❤️", category: "Deep love" },

  { text: "My favourite place is right next to you 🫶", category: "Cute" },
  { text: "Falling for you, again and again 💞", category: "Romantic" },
  { text: "You're still my favourite notification. 💌", category: "Cute" },
  { text: "You make ordinary moments feel extraordinary 🫶", category: "Romantic" },

  { text: "Out of all the people in this world, somehow I found you. And I'm so glad. ❤️", category: "Deep love" },

  { text: "I never get tired of choosing you. 💍", category: "Romantic" },
  { text: "Your messages still make me smile 💌", category: "Cute" },

  // Middle: Romantic and emotionally meaningful
  { text: "Somewhere between the little moments, you became my favourite part of life. 💗", category: "Deep love" },
  { text: "You feel like my favourite kind of forever. 🤍", category: "Deep love" },
  { text: "My life starts with you... 💫", category: "Romantic" },
  { text: "You turned ordinary moments into memories I never want to forget. 💞", category: "Romantic" },
  { text: "In a world full of changes, you're my constant. 💗", category: "Deep love" },
  { text: "You make even the quietest moments feel special. 🤍", category: "Romantic" },
  { text: "My favourite part of every day is knowing I get to share it with you. 🫶", category: "Cute" },
  { text: "I could spend a thousand ordinary days with you and still want one more. ✨", category: "Romantic" },
  { text: "If I could relive one moment, I'd choose you again. ✨", category: "Deep love" },
  { text: "With you, even an ordinary day feels like a memory. 🫶", category: "Cute" },
  { text: "A thousand little reasons, all leading back to you. ❤️", category: "Deep love" },
  { text: "Somehow, you make my world feel special. 💗", category: "Romantic" },
  { text: "One look at you, and the day gets better. 😊", category: "Cute" },
  { text: "Love is in the little things we do together. 💕", category: "Romantic" },
  { text: "Are you always this cute, or is it just around me? 😉", category: "Flirty" },

  // Bottom: More specific or needing improvement
  { text: "Miles apart, but you're never far from my heart. 🌙", category: "Long distance" },
  { text: "I still look at you and wonder how much I'm lucky. ✨", category: "Romantic" },
  { text: "My heart found you, my favorite person. 💞", category: "Deep love" },
  { text: "Every little thing reminds me of you. ❤️", category: "Romantic" },

  { text: "Our first date, and already a memory I'll keep forever. 🤍", category: "First date" },
{ text: "One date closer to a thousand more moments together. 🫶", category: "First date" },
{ text: "A little nervous, a lot excited, and happy it was you. ❤️", category: "First date" },
{ text: "The beginning of something that feels special. ✨", category: "First date" },
{ text: "If every date feels like this, I'm already looking forward to the next one. 💗", category: "First date" },

{ text: "Another year of us, and I'd still choose you. ❤️", category: "Anniversary" },
{ text: "One more year, countless memories, and a love that keeps growing. 💞", category: "Anniversary" },
{ text: "We started with a moment, and look how far we've come. 🫶", category: "Anniversary" },
{ text: "Every chapter with you is my favourite one. 🤍", category: "Anniversary" },
{ text: "Still my favourite person, today and every anniversary after this. 💍", category: "Anniversary" },


{ text: "Stop being so cute. I'm trying to act normal around you. 😉", category: "Flirty" },
{ text: "You're making it very hard to play it cool. 😏", category: "Flirty" },
{ text: "My favourite distraction has a name, and it's you. 💋", category: "Flirty" },
{ text: "So... when are you taking me on another date? 😉", category: "Flirty" },
{ text: "I was going to flirt with you, but then you smiled. ❤️", category: "Flirty" },

{ text: "Different places, same heart. ❤️", category: "Long distance" },
{ text: "Counting the days until a hug replaces this screen. 🫶", category: "Long distance" },
{ text: "I wish I could turn every goodnight text into a goodnight kiss. 💋", category: "Long distance" },
{ text: "The distance is hard, but you're worth every mile. 🤍", category: "Long distance" },
{ text: "Until I see you again, I'll keep finding you in every little thing. 🌙", category: "Long distance" },
],


  nature: [
    { text: "Somewhere between the trees, I found myself 🌿", category: "Peaceful" },
    { text: "A little more sunshine, a little less stress ☀️", category: "Positive vibes" },
    { text: "Collecting moments, not things 🍃", category: "Nature vibes" },
    { text: "The sky has its own way of healing 💙", category: "Peaceful" },
    { text: "Lost in the right direction 🌲", category: "Adventure" },
    { text: "Where the earth feels like home 🌎", category: "Nature vibes" },
    { text: "Chasing sunsets and quiet moments 🌅", category: "Sunset" },
    { text: "Nature never goes out of style 🌿", category: "Nature vibes" },
    { text: "Peace looks a lot like this 🤍", category: "Peaceful" },
    { text: "Taking the scenic route, always 🏞️", category: "Adventure" },
    { text: "The best views come with a deep breath 🌄", category: "Peaceful" },
    { text: "Green spaces, clear thoughts 🌱", category: "Peaceful" },
    { text: "Just me and the endless sky ☁️", category: "Sky" },
    { text: "A moment of calm in a noisy world 🍃", category: "Peaceful" },
    { text: "Meet me where the wild things grow 🌾", category: "Nature vibes" },
    { text: "The mountains are calling, and I need to go 🏔️", category: "Adventure" },
    { text: "Sunshine feels different when you slow down 🌞", category: "Positive vibes" },
    { text: "Every sunset is a reason to pause 🌇", category: "Sunset" },
    { text: "Wild air, quiet mind, happy heart 💚", category: "Peaceful" },
    { text: "Let the wind carry away what you don't need 🌬️", category: "Peaceful" },
    { text: "The world is beautiful when you take your time 🌍", category: "Nature vibes" },
    { text: "Blue skies and nowhere to rush 💙", category: "Sky" },
    { text: "A little closer to nature, a little closer to peace 🌿", category: "Peaceful" },
    { text: "Views that make you forget to check your phone 📵", category: "Nature vibes" },
    { text: "Earth tones and peaceful souls 🤎", category: "Nature vibes" },
    { text: "Breathing in the beauty, one moment at a time 🌳", category: "Peaceful" },
    { text: "The kind of place that makes you stay a little longer 🏞️", category: "Nature vibes" },
    { text: "Cloud watching is my kind of therapy ☁️", category: "Sky" },
    { text: "If you need me, I'll be outside 🌻", category: "Nature vibes" },
    { text: "Finding magic in the ordinary 🌼", category: "Nature vibes" },
    { text: "Fresh air, fresh perspective 🌱", category: "Positive vibes" },
    { text: "Let the flowers remind you to keep growing 🌸", category: "Positive vibes" },
    { text: "Nothing to prove, nowhere to be 🌾", category: "Peaceful" },
    { text: "A quiet morning surrounded by green 🌿", category: "Peaceful" },
    { text: "Where the river flows, let your worries go 💧", category: "Peaceful" },
    { text: "Sunlight, fresh air, and a grateful heart ☀️", category: "Positive vibes" },
    { text: "The wild has a way of bringing you back to yourself 🌲", category: "Nature vibes" },
    { text: "Some views deserve more than a photograph 📸", category: "Nature vibes" },
    { text: "Just a small human in a beautiful world 🌎", category: "Nature vibes" },
    { text: "A slower day, a softer sky, a quieter mind. 🌿", category: "Peaceful" },
    { text: "Some mornings are made for fresh air and no plans. ☀️", category: "Morning" },
    { text: "Let the horizon remind you how wide the world is. 🌅", category: "Sunset" },
    { text: "A little silence can say more than words. 🍃", category: "Peaceful" },
    { text: "Under open skies, everything feels possible. 💙", category: "Sky" },
    { text: "Taking a moment to notice the beauty around me. 🌼", category: "Nature vibes" },
    { text: "The simplest views often stay with us the longest. 🌄", category: "Nature vibes" },
    { text: "Some days call for trees, fresh air, and a little space. 🌲", category: "Peaceful" },
    { text: "A peaceful place to let the mind wander. ☁️", category: "Peaceful" },
    { text: "The beauty is in being here, right now. 🌿", category: "Nature vibes" },
  ],

  birthday: [
    { text: "Feeling extra loved today. 🤍", category: "Birthday vibes" },
    { text: "Just here for the cake and the memories 🎉", category: "Celebration" },
    { text: "Cheers to another chapter of my life. 🥂", category: "Birthday vibes" },
    { text: "Growing older, but never growing out of birthdays 🎈", category: "Funny" },
    { text: "Today is all about good vibes and cake 🎂", category: "Celebration" },
    { text: "Making memories and eating cake 🎂✨", category: "Celebration" },
    { text: "One more year, a little wiser, and still celebrating. 🎈✨", category: "Birthday vibes" },
    { text: "Birthday mood: on 🎂✨", category: "Birthday vibes" },
    { text: "One more year, one more reason to celebrate 🎉", category: "Celebration" },
    { text: "A new age, new memories, and more reasons to smile. 🎂", category: "Birthday vibes" },
    { text: "Another trip around the sun, and I'm just getting started. ☀️", category: "Birthday vibes" },
    { text: "Today deserves a little extra sparkle. ✨", category: "Celebration" },
    { text: "Cake, candles, and a heart full of gratitude. 🎂", category: "Celebration" },
    { text: "Here's to the memories waiting to be made. 🥂", category: "Birthday wishes" },
    { text: "A birthday reminder to celebrate how far I've come. 🎉", category: "Self love" },
    { text: "More life, more laughter, more moments worth keeping. 🎈", category: "Birthday vibes" },
    { text: "Making this chapter one to remember. ✨", category: "Birthday vibes" },
    { text: "Growing through life, one birthday at a time. 🌷", category: "Self love" },
    { text: "A little older, a lot more grateful. 🤍", category: "Self love" },
  ],

  friends: [
    { text: "Life is better with friends 🫶", category: "Friendship" },
    { text: "Just good friends and good memories ✨", category: "Memories" },
    { text: "Some friendships just feel like home 🏠", category: "Close friends" },
    { text: "Making memories with my favourite people 📸", category: "Memories" },
    { text: "No matter where life takes us, these memories stay 🫶", category: "Friendship" },
    { text: "Good times + crazy friends = best memories 😂", category: "Funny" },
    { text: "Friends who became family 🤍", category: "Close friends" },
    { text: "Some people just make everything better ✨", category: "Friendship" },
    { text: "The kind of people you never want to outgrow 🤍", category: "Close friends" },
    { text: "Chaos, laughs, and memories 📸", category: "Funny" },
    { text: "Same people, different memories 🫶", category: "Memories" },
    { text: "The best stories always include my favourite people. 🫶", category: "Friendship" },
    { text: "A little laughter makes every memory better. 😂", category: "Funny" },
    { text: "Different personalities, one unforgettable friendship. ✨", category: "Friendship" },
    { text: "Some days become special because of who you're with. 🤍", category: "Memories" },
    { text: "The group chat could never tell the whole story. 📱", category: "Funny" },
    { text: "Good friends make the ordinary feel legendary. 🎉", category: "Friendship" },
    { text: "Proof that the best moments aren't planned. 📸", category: "Memories" },
    { text: "Collecting laughs with the people who get me. 🫶", category: "Close friends" },
    { text: "Here's to friendships that make life lighter. 💛", category: "Friendship" },
    { text: "Every picture has a story only we understand. 😂", category: "Funny" },
  ],

  attitude: [
    { text: "I know who I am, and that's enough 😎", category: "Confidence" },
    { text: "Not everyone has to like me, and that's okay ✨", category: "Self respect" },
    { text: "Less talk, more action 💯", category: "Motivation" },
    { text: "I'm not here to fit in 😎", category: "Confidence" },
    { text: "My vibe speaks before I do ✨", category: "Attitude" },
    { text: "Stay real, stay different 🔥", category: "Attitude" },
    { text: "I don't chase, I attract 😎", category: "Confidence" },
    { text: "Silent moves, loud results 🔥", category: "Motivation" },
    { text: "I'm my own competition 😎", category: "Self growth" },
    { text: "Born to stand out ✨", category: "Confidence" },
    { text: "No attitude, just standards 😌", category: "Self respect" },
    { text: "I'm building a life that feels like me. 🔥", category: "Self growth" },
    { text: "Quiet confidence, clear intentions. 😎", category: "Confidence" },
    { text: "My path, my pace, my priorities. 💯", category: "Self growth" },
    { text: "I know my worth without explaining it. ✨", category: "Self respect" },
    { text: "Focused on progress, not approval. 🎯", category: "Motivation" },
    { text: "Different mindset, different direction. 🚀", category: "Self growth" },
    { text: "Protecting my peace is part of the plan. 😌", category: "Self respect" },
    { text: "Let the results introduce me. 🔥", category: "Motivation" },
    { text: "No need to compete when you're becoming your best. 💯", category: "Self growth" },
    { text: "I move differently when I know my purpose. 😎", category: "Confidence" },
  ],

  travel: [
    { text: "Some places just stay with you ✈️", category: "Travel memories" },
    { text: "Out of office, into the world 🌍", category: "Adventure" },
    { text: "Collecting moments from places I'll never forget ✨", category: "Travel memories" },
    { text: "Somewhere far from everything 🌍", category: "Escape" },
    { text: "I think I belong somewhere on the road ✈️", category: "Adventure" },
    { text: "Just me and a place I've never been before 🤍", category: "Adventure" },
    { text: "The view was worth the journey 🌄", category: "Travel memories" },
    { text: "Gone somewhere I feel more alive 🌍", category: "Adventure" },
    { text: "Not all who wander are lost ✈️", category: "Adventure" },
    { text: "Take me where the Wi-Fi is weak and the memories are strong 🌄", category: "Funny" },
    { text: "New streets, new stories, same curious heart. 🌍", category: "Adventure" },
    { text: "A little lost, a lot inspired. ✈️", category: "Adventure" },
    { text: "Leaving room for the unexpected. 🗺️", category: "Adventure" },
    { text: "Every journey gives you a new perspective. 🌄", category: "Travel memories" },
    { text: "Postcards from a day I'll remember. 📸", category: "Travel memories" },
    { text: "Taking the long way because the view is worth it. 🚗", category: "Adventure" },
    { text: "Some memories only happen far from home. 🤍", category: "Travel memories" },
    { text: "One more place to add to the story. 🌎", category: "Adventure" },
    { text: "Following the road wherever it leads. ✨", category: "Adventure" },
    { text: "The best souvenir is the memory itself. 🧳", category: "Travel memories" },
  ],
};


// const categoryDescriptions = {
//   love: "Find the perfect love caption for romantic photos, couple moments, and little things that make your relationship special. Choose your favourite and copy it for your post.",

//   nature: "Find nature captions for scenic views, sunsets, mountain escapes, and peaceful moments outdoors. Choose your favourite and copy it for your post.",

//   birthday: "Find the perfect birthday caption for your selfies, celebrations, and special moments. Choose your favourite and copy it for your post.",

//   friends: "Find friendship captions for group photos, fun outings, and memories with your favourite people. Choose your favourite and copy it for your post.",

//   attitude: "Find attitude captions for selfies, confident moments, and posts that express your personality. Choose your favourite and copy it for your post.",

//   travel: "Find travel captions for adventures, holiday photos, beautiful destinations, and memories from the road. Choose your favourite and copy it for your post.",
// };


const categoryDescriptions = {
  love: "Find the perfect love caption for romantic photos, couple moments, and little things that make your relationship special. Use these captions for Instagram, Facebook, Pinterest, and WhatsApp Status. Choose your favourite and copy it for your post.",

  nature: "Find nature captions for scenic views, sunsets, mountain escapes, and peaceful moments outdoors. Use these captions for Instagram, Facebook, Pinterest, and WhatsApp Status. Choose your favourite and copy it for your post.",

  birthday: "Find the perfect birthday caption for your selfies, celebrations, and special moments. Use these captions for Instagram, Facebook, Pinterest, and WhatsApp Status. Choose your favourite and copy it for your post.",

  friends: "Find friendship captions for group photos, fun outings, and memories with your favourite people. Use these captions for Instagram, Facebook, Pinterest, and WhatsApp Status. Choose your favourite and copy it for your post.",

  attitude: "Find attitude captions for selfies, confident moments, and posts that express your personality. Use these captions for Instagram, Facebook, Pinterest, and WhatsApp Status. Choose your favourite and copy it for your post.",

  travel: "Find travel captions for adventures, holiday photos, beautiful destinations, and memories from the road. Use these captions for Instagram, Facebook, Pinterest, and WhatsApp Status. Choose your favourite and copy it for your post.",
};

const CaptionIdeas = (props) => {
  const { category = "love" } = useParams();
  const [copiedIndex, setCopiedIndex] = useState(null);
    let fromHome = props.componentFrom === "home"
  // const currentCategory = category.toLowerCase();
   const currentCategory = (props?.category || category ).toLowerCase();

  const captions = captionData[currentCategory];

  
const [selectedSubcategory, setSelectedSubcategory] = useState("All");

useEffect(() => {
  setSelectedSubcategory("All");
}, [currentCategory]);

const subcategories = [
  "All",
  ...new Set((captions || []).map((caption) => caption.category)),
];


const handleSubcategoryClick = (subcategory) => {
  trackEvent("caption_ideas_filter_click", {
    action_type: "filter_caption",
    topic: `${currentCategory} - ${subcategory}`,
    // filter_name: subcategory,
    from: timeForPage(),
  });

  setSelectedSubcategory(subcategory);
};
// let filterCaption = captions.filter(
//         (caption) => caption.category === selectedSubcategory
//       )
// const filteredCaptions = selectedSubcategory === "All" ? captions : filterCaption;

const filterCaption =
  selectedSubcategory === "All"
    ? captions
    : captions.filter(
        (caption) => caption.category === selectedSubcategory
      );

const filteredCaptions =
  props.componentFrom === "home"
    ? filterCaption.slice(0, 3)
    : filterCaption;


  const copyCaption = async (text, captionCategory, index) => {
     trackEvent("caption_idea_copy", {
        action_type: "copy_caption",
        caption_text: text,
        topic: captionCategory,
        from: timeForPage(),
      });

    try {
      
      await navigator.clipboard.writeText(text);
      setCopiedIndex(index);
      toast.success("Caption copied to clipboard!")
      setTimeout(() => setCopiedIndex(null), 1800);
    } catch (error) {
      console.error("Unable to copy caption:", error);
        toast.error("Couldn't copy the caption. Please try again.");
    }
  };

  if (!captions) {
    return (
     <CaptionNotFound currentCategory={currentCategory} />

    );
  }

  const title =
    currentCategory.charAt(0).toUpperCase() +
    currentCategory.slice(1);

  return (
    <>
    {props.componentFrom !== "home" && (  
      <Helmet>
        <title>{title} Captions | BrowseNext</title>
        <meta
          name="description"
        content={categoryDescriptions[currentCategory]}
        />
        <link
          rel="canonical"
          href={`https://www.browsenext.today/captions/${currentCategory}`}
        />
      </Helmet>
      )
      }
    
{/* caption-ideas-page */}
      <main className={`container app_container caption_caption ${fromHome ? "p-0" : "" }`}>
         <div className="new_caption_topic_list">

                {props.componentFrom !== "home" && CAPTION_TOPICS.map((topic) => {
    const category = topic.label.toLowerCase();

    return (
    <NavLink
  key={topic.label}
  to={`/captions/${category}`}
  className={({ isActive }) =>
    `caption_topic_button caption-page-link ${
      isActive ? "active" : ""
    }`
  }
>
  {topic.label} {topic.emoji}
</NavLink>
    );
  })}
                </div>

        <h1 className={`caption-ideas-heading ${fromHome ? 'adjust_font' : ''}`}>
          {/* {title} Captions */}
          {fromHome ? `Captions Ideas for ${title} Post` : `${title} Captions`}
        </h1>

       {props.componentFrom !== "home" && (<>
        <p className="caption-ideas-description last_updated_text ">
          {/* Find a caption you love and copy it for your next post. */}
           {categoryDescriptions[currentCategory]}
        </p>
       
       </>)}

        
<div className={`caption-subcategory-filters ${fromHome ? "caption_list_auto_filter" : "" }`}>
  {subcategories.map((subcategory) => (
    <button
      key={subcategory}
      type="button"
      className={`caption-filter-button ${
        selectedSubcategory === subcategory ? "active" : ""
      }`}
      // onClick={() => setSelectedSubcategory(subcategory)}
      onClick={() => handleSubcategoryClick(subcategory)}
      aria-pressed={selectedSubcategory === subcategory}
    >
      {subcategory}
    </button>
  ))}
</div>


        <div className={`caption-ideas-list ${fromHome ? "caption_list_auto" : "" }`}>
          {filteredCaptions.map((caption, index) => (
            <article
              className="caption-idea-card"
              key={caption.text}
            >
              <div className="caption-header">

 <p className="caption-idea-text">
                {caption.text}
              </p>
                  <button
                  type="button"
                  className="caption-copy-button d-none"
                  onClick={() =>
                    copyCaption(caption.text,currentCategory,  index)
                  }
                >
                  {copiedIndex === index
                    ? (<><i class="fa-solid fa-circle-check correct_caption"></i> Caption Copied</>)
                    : "Copy caption"}
                </button>
              </div>
             

              <div className="caption-idea-footer">
                <span className="caption-idea-category">
                  {caption.category}
                </span>

            <div className="action_caption_idea">
   

                <button
                  type="button"
                  className="caption-copy-button"
                  onClick={() =>
                    copyCaption(caption.text, currentCategory, index)
                  }
                >
                  {copiedIndex === index
                    ? (<><i class="fa-solid fa-circle-check correct_caption"></i> Caption Copied</>)
                    : (<>
                    
                    Copy caption
                    </>)
                    }
                </button>
              </div>

              </div>
            </article>
          ))}
        </div>
      </main>
    </>
  );
};

export default CaptionIdeas;


function CaptionNotFound(props){
  return(<>
   <main className="container app_container caption_caption caption-ideas-page">
      <div className="new_caption_topic_list">
        {CAPTION_TOPICS.map((topic) => {
          const topicCategory = topic.label.toLowerCase();

          return (
            <NavLink
              key={topic.label}
              to={`/captions/${topicCategory}`}
              className={({ isActive }) =>
                `caption_topic_button caption-page-link ${
                  isActive ? "active" : ""
                }`
              }
            >
              {topic.label} {topic.emoji}
            </NavLink>
          );
        })}
      </div>

      {/* <h1 className="caption-ideas-heading">
        Captions not found
      </h1>

      <p className="caption-ideas-description">
        We couldn't find this caption category.
      </p> */}


        <div className="caption_not_info">
          <h1 className="caption-not-found-heading">
          No captions for {props.currentCategory} yet!
        </h1>

        <p className="caption-not-found-description last_updated_text">
          We couldn't find captions for {props.currentCategory} right now.
          But don't worry — explore our available caption ideas{" "}
  <strong>by choosing one of the topics above</strong>{" "}  and find the perfect words for your next post.
        </p>
          
        </div>
    </main>
  
  </>)
}